import { useEffect, useState } from "react";
import api, { fmtMoney } from "../../api";
import Layout from "../../components/Layout";

export default function Metrics() {
  const [m, setM] = useState(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only load by design
  useEffect(() => { api.get("/metrics").then((r) => setM(r.data)); }, []);

  const cards = m ? [
    { label: "Request → scheduled", value: `${m.avg_request_to_scheduled_days}d`, hint: "average" },
    { label: "Completion → invoice", value: `${m.avg_completion_to_invoice_days}d`, hint: "average" },
    { label: "Days to payment", value: `${m.avg_days_to_payment}d`, hint: "after invoice sent" },
    { label: "Open requests", value: m.open_requests, hint: "add-ons in flight" },
    { label: "Visits completed", value: m.visits_completed_this_month, hint: "this month" },
    { label: "Dispatched vs self", value: `${m.jobs_dispatched} / ${m.jobs_self_performed}`, hint: "crew vs you" },
    { label: "Outstanding", value: fmtMoney(m.total_outstanding), hint: "unpaid invoices" },
    { label: "Revenue (12 mo)", value: fmtMoney(m.revenue_trailing_12m), hint: `${m.tax_threshold_pct}% of $30k small-supplier threshold${m.tax_enabled ? ` · ${m.tax_label || "HST"} on` : ` · ${m.tax_label || "HST"} off`}` },
    { label: "Leads brought in", value: m.leads_total, hint: `${m.leads_open_count} in current period` },
    { label: "Lead conversion", value: `${m.leads_conversion_pct}%`, hint: `${m.leads_converted} became customers` },
    { label: "Commission owing", value: fmtMoney(m.leads_commission_owing), hint: "lead bonuses, current period" },
  ] : [];

  return (
    <Layout title="Numbers">
      <a data-testid="export-csv" href={`${process.env.REACT_APP_BACKEND_URL}/api/reports/export`}
        className="mb-4 block h-14 w-full rounded-md border border-primary text-center font-bold leading-[3.5rem] text-primary transition-colors hover:bg-primary/5">
        Export invoices (CSV)
      </a>
      <div className="grid grid-cols-2 gap-3" data-testid="metrics-grid">
        {!m && <p className="text-muted-foreground">Loading…</p>}
        {cards.map((c) => (
          <div key={c.label} className="card-flat p-5" data-testid={`metric-${c.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <p className="label-caps">{c.label}</p>
            <p className="mt-2 font-heading text-3xl font-bold">{c.value}</p>
            <p className="text-xs text-muted-foreground">{c.hint}</p>
          </div>
        ))}
      </div>
    </Layout>
  );
}
